module.exports = __webpack_public_path__ + "static/media/logo-horizontal.d64802d5.png";